import { render, staticRenderFns } from "./Affiliates.vue?vue&type=template&id=24773a64"
import script from "./Affiliates.vue?vue&type=script&lang=js"
export * from "./Affiliates.vue?vue&type=script&lang=js"
import style0 from "./Affiliates.vue?vue&type=style&index=0&id=24773a64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports